import { Component, OnInit } from '@angular/core';
import { SessionService } from 'app/components/common/session/session.service';
import { NgbActiveModal, NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { ENV } from 'environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { UtilsService } from "../utils/utils.service";

@Component({
  selector: 'app-modal-redirect-sda',
  templateUrl: './modal-redirect-sda.component.html',
  styleUrls: ['./modal-redirect-sda.component.css']
})
export class ModalRedirectSdaComponent implements OnInit {

  loader: any = { count: 0 };
  alertType: string = '';
  alertMessage: string = '';
  url: string = '';

  eventData: object = {};

  constructor(private sessionService: SessionService, private ngbActiveModal: NgbActiveModal, private translateService: TranslateService,
  private utilsService: UtilsService) { }

  accept(){
    this.ngbActiveModal.close();
  };

  ngOnInit() {
    this.eventData = JSON.parse(this.sessionService.get('eventData', false) || '{}');
    let lang = this.utilsService.mapLanguageCode(this.translateService.currentLang)
    this.url = ENV.REGISTRATION_FRONTOFFICE_URL + '/' + lang + '/' + this.eventData['sapCode'] + '/WEB';
  }

}
